<template>
  <div class="not-found-page">
    <div class="page-card-wrapper">
      <div class="page-card-title">
        <span class="page-card-title-text">404</span>
      </div>
      <div class="page-card-content">
        <h1>Oops!</h1>
        <h3>The page you're looking for is not here.</h3>
        <span class="pointer underline" @click="redirectTo()"
          >Back to page</span
        >
        <span class="pointer underline ml-20" @click="logout()">Logout</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectTo() {
      this.$router.push({ path: '/' })
    },
    logout() {
      this.$loading({
        lock: true,
        text: this.$t('text.sign_out') + '...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$store.dispatch('user/logout')
    }
  }
}
</script>
